import { post, get } from "./api_helper";

// Login Method
export const loginUser = async (credentials) => {
    try {
        console.log('Attempting login with:', credentials);
        const response = await post('/auth/login', credentials);
        console.log('Login response:', response);
        return response;
    } catch (error) {
        console.error('Login error in auth_helper:', error);
        throw error;
    }
};

// Register Method
export const registerUser = async (userData) => {
    try {
        console.log('Attempting registration with:', userData);
        const response = await post('/auth/signup', userData);
        console.log('Registration response:', response);
        return response;
    } catch (error) {
        console.error('Registration error in auth_helper:', error);
        throw error;
    }
};

// Forgot Password Method
export const forgotPassword = async (email) => {
    try {
        console.log('Attempting forgot password with:', email);
        const response = await post('/auth/forgot-password', { email });
        console.log('Forgot password response:', response);
        return response;
    } catch (error) {
        console.error('Forgot password error in auth_helper:', error);
        throw error;
    }
};

// Reset Password Method
export const resetPassword = async (token, newPassword) => {
    try {
        console.log('Attempting password reset with token:', token);
        const response = await post('/auth/reset-password', { token, newPassword });
        console.log('Password reset response:', response);
        return response;
    } catch (error) {
        console.error('Password reset error in auth_helper:', error);
        throw error;
    }
};

// Get User Profile
export const getUserProfile = async () => {
    try {
        console.log('Attempting to get user profile');
        const response = await get('/auth/profile');
        console.log('User profile response:', response);
        return response;
    } catch (error) {
        console.error('Get profile error in auth_helper:', error);
        throw error;
    }
};

// Logout Method
export const logoutUser = async () => {
    try {
        console.log('Attempting logout');
        const response = await post('/auth/logout');
        console.log('Logout response:', response);
        return response;
    } catch (error) {
        console.error('Logout error in auth_helper:', error);
        throw error;
    }
}; 